import React from 'react';
import theme from './Cards.module.scss';

const CardHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...rest }) => {
    return (
        <div {...rest} className={theme.header}>
            {children}
        </div>
    );
};

export default CardHeader;